import { ChevronLeftRounded, ChevronRightRounded } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { ActionButton } from '@pages/ActionButton';
import { addMonths, format, isSameMonth, startOfMonth } from 'date-fns';
import css from './MonthNav.module.scss';

export type MonthDirection = 'prev' | 'next' | 'today';

/** The one month selector, driving both views. */
export function MonthNav({
  month,
  now,
  onChange,
}: {
  month: Date;
  now: Date;
  onChange: (next: Date, direction: MonthDirection) => void;
}) {
  return (
    <div className={css.monthNav}>
      <IconButton
        className={css.navButton}
        aria-label="Previous month"
        onClick={() => onChange(addMonths(month, -1), 'prev')}
      >
        <ChevronLeftRounded />
      </IconButton>
      <h2 className={css.monthTitle}>{format(month, 'MMMM yyyy')}</h2>
      <IconButton
        className={css.navButton}
        aria-label="Next month"
        onClick={() => onChange(addMonths(month, 1), 'next')}
      >
        <ChevronRightRounded />
      </IconButton>
      {!isSameMonth(month, now) && (
        <ActionButton variant="secondary" onClick={() => onChange(startOfMonth(now), 'today')}>
          Today
        </ActionButton>
      )}
    </div>
  );
}
